// extracted by mini-css-extract-plugin
export default {"logo":"LogoGovbr-module__[local]___RIdWG","invert":"LogoGovbr-module__[local]___tJS4m"};